import Dashboard from "../Pages/Dashboard";
import Pricing from "../Pages/Pricing/Pricing";
import ResetPassword from "../Pages/ResetPasswordPage/ResetPasswordPage";
import Feedback from "../Pages/Feedback/Feedback";
import { Component } from "react";
import EditProfile from "../Pages/EditProfile/EditProfile";
import FeedbackTable from "../Pages/Feedback/FeedbackTable";
import CreatePage from "../Pages/Reports/CreateReport/CreatePage";
import AllPages from "../Pages/Reports/AllReports/AllPages";
import ManagePatients from "../Pages/Patients/ManagePatients/ManagePatients";
import PatientDetails from "../Pages/Patients/PatientDetails/PatientDetails";
import GenerateDoc from "../Pages/Patients/GenerateDoc/GenerateDoc";
import GenerateDocPreview from "../Pages/Patients/GenerateDocPreview/GenerateDocPreview";
import TemplateList from "../Pages/TemplateList";
import AdminPatients from "../Pages/AdminPatients";
import AdminReports from "../Pages/AdminReports";
import AdminTemplates from "../Pages/AdminTemplates";

const routes = [
  { path: "", Component: <Dashboard /> },
  { path: "/report/list", Component: <AllPages /> },
  { path: "/template/list", Component: <TemplateList /> },
  { path: "/report/create_new", Component: <CreatePage /> },
  { path: `/report/edit/:report_id`, Component: <CreatePage /> },

  { path: "/patient/list", Component: <ManagePatients /> },
  { path: "/patient/report_generate", Component: <GenerateDoc /> },
  { path: "/patient/report_generate/:report_id/preview", Component: <GenerateDocPreview /> },
  { path: "/patient/details", Component: <PatientDetails /> },

  { path: "/pricing/upgrade-plan", Component: <Pricing /> },
  { path: "/user/feedback", Component: <Feedback /> },
  { path: "/feedback/list", Component: <FeedbackTable /> },
  { path: "/user/reset_password", Component: <ResetPassword /> },

  { path: "/user/edit_profile", Component: <EditProfile /> },

  { path: "/admin/patients", Component: <AdminPatients /> },
  { path: "/admin/reports", Component: <AdminReports /> },
  { path: "/admin/templates", Component: <AdminTemplates /> }
]

export default routes;